import {
  AccountBookOutlined,
  BarChartOutlined,
  BuildOutlined,
  CalendarOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileProtectOutlined,
  PaperClipOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  SwapOutlined
} from "@ant-design/icons"
import type { ComponentType, CSSProperties } from "react"

type IconComponent = ComponentType<{ className?: string; style?: CSSProperties }>

// Single source of truth for a Document Type's icon — reused by the table
// cell, its dropdown, bulk document type, filters and File Details, so a
// type never gets a different icon depending on where it's rendered.
//
// Unlike Status, `DOCUMENT_TYPE_SEED` (apps/templates_management/
// list_options.py) marks every value `is_system=False` — a company can add
// its own types beyond these defaults — so this map covers the seeded set
// and anything else falls back to a plain document icon rather than
// breaking or guessing.
const DOCUMENT_TYPE_ICONS: Record<string, IconComponent> = {
  contract: FileProtectOutlined,
  proposal: FileDoneOutlined,
  invoice: AccountBookOutlined,
  change_request: SwapOutlined,
  drawing: BuildOutlined,
  rfi: QuestionCircleOutlined,
  submittal: ProfileOutlined,
  report: BarChartOutlined,
  purchase_order: ShoppingCartOutlined,
  schedule: CalendarOutlined,
  meeting_minutes: SolutionOutlined,
  other: PaperClipOutlined
}

export const documentTypeIcon = (
  documentType: string | null | undefined
): IconComponent => (documentType && DOCUMENT_TYPE_ICONS[documentType]) || FileOutlined
